import { CrudManager } from "./CrudManager";

export default function AdminServices() {
  return (
    <CrudManager
      testidPrefix="admin-services"
      title="Services"
      description="Manage hospital services shown on the public site."
      endpoint="/admin/services"
      columns={[
        { key: "name", label: "Name" },
        { key: "icon", label: "Icon" },
        { key: "description", label: "Description" },
      ]}
      emptyValues={{ name: "", icon: "Activity", description: "", image_url: "", order: 0 }}
      fields={[
        { name: "name", label: "Name", type: "text" },
        { name: "icon", label: "Lucide icon name", type: "text" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "image_url", label: "Image URL", type: "url" },
        { name: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
